import React, { useRef } from 'react';
import { useSpinradContext } from '../../context/SpinradContext';
import { findQuestionVideo, theme } from '../../data';
import ChalkNote from '../chalkNote';
import VideoBox from './VideoBox';
import {
  AddFab,
  BoardWb,
  Topbar,
  WbEmpty,
  WbEmptyMsg,
  WbNotes,
  WbQuestion,
  WqFrom,
} from './styles';

const Board: React.FC = () => {
  const { activeCard, addNote } = useSpinradContext();
  const gridRef = useRef<HTMLDivElement>(null);
  const boardRef = useRef<HTMLDivElement>(null);

  if (!activeCard) return <BoardWb ref={boardRef} />;

  const th = theme(activeCard.from);
  const { notes } = activeCard;
  const videoUrl = findQuestionVideo(activeCard.q);
  const maxY = notes.reduce((m, n) => Math.max(m, n.y + (n.height || 160)), 0);
  const minHeight = maxY + 40;

  const handleAddNote = (): void => {
    const id = addNote(activeCard.id);
    setTimeout(() => {
      const el = document.querySelector<HTMLElement>(
        `[data-note-id="${id}"] [data-cn-text]`,
      );
      if (el) {
        el.focus();
        const range = document.createRange();
        range.selectNodeContents(el);
        const sel = window.getSelection();
        sel?.removeAllRanges();
        sel?.addRange(range);
      }
    }, 30);
  };

  return (
    <BoardWb ref={boardRef}>
      <Topbar>
        {videoUrl && <VideoBox videoUrl={videoUrl} />}
        <WbQuestion>
          {activeCard.q}
          <WqFrom $color={th.color}>Aus: {th.name}</WqFrom>
        </WbQuestion>
      </Topbar>

      <AddFab type="button" onClick={handleAddNote}>
        <span style={{ fontSize: 26, lineHeight: 1 }}>＋</span> Notiz anheften
      </AddFab>

      <WbNotes ref={gridRef} $minHeight={minHeight}>
        {notes.length === 0 && (
          <WbEmpty>
            <WbEmptyMsg>
              Noch keine Notizen. Heftet eure erste Notiz an.
            </WbEmptyMsg>
          </WbEmpty>
        )}
        {notes.map(n => (
          <ChalkNote
            key={n.id}
            cardId={activeCard.id}
            note={n}
            color={th.color}
            gridRef={gridRef}
            boardRef={boardRef}
          />
        ))}
      </WbNotes>
    </BoardWb>
  );
};

export default Board;
